import { render, staticRenderFns } from "./HelpPricingAndLimitations.vue?vue&type=template&id=3f2ef229&scoped=true"
import script from "./HelpPricingAndLimitations.vue?vue&type=script&lang=ts"
export * from "./HelpPricingAndLimitations.vue?vue&type=script&lang=ts"
import style0 from "./HelpPricingAndLimitations.vue?vue&type=style&index=0&id=3f2ef229&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2ef229",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2ef229')) {
      api.createRecord('3f2ef229', component.options)
    } else {
      api.reload('3f2ef229', component.options)
    }
    module.hot.accept("./HelpPricingAndLimitations.vue?vue&type=template&id=3f2ef229&scoped=true", function () {
      api.rerender('3f2ef229', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Help/HelpPricingAndLimitations.vue"
export default component.exports